import { Box, styled } from "@mui/material";
import { Select } from "@pmag/ui-components";

export const PriceCellContainer = styled(Box)({
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
});

export const PriceCellRightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(1),
    height: "-webkit-fill-available",
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
        height: 32,
        "& .MuiInputBase-root": {
            height: 32,
        },
    },
}));
